<template>
    <div class="page">
        <div class="step-sect affiliate">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-6 col-md-10">
                        <div class="step_list">
                            <div class="step_item">
                                <p class="min p-bold">Become a partner</p>
                            </div>
                            <div class="step_item">
                                <div class="success-item">

                                </div>
                            </div>
                            <div class="step_item">
                                <p class="min p-bold">Advertise</p>
                            </div>
                            <div class="step_item">
                                <div class="success-item">

                                </div>
                            </div>
                            <div class="step_item">
                                <p class="min p-bold">Earn</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="affiliate-main-sect">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-lg-6">
                        <div class="title">
                            <h1 class="p-title relawayBold p-black mb-0">TecknaEl Affiliate</h1>
                        </div>
                        <div class="desk">
                            <p class="p-bold mb-0">Want to connect your digital platform to a top-notch affiliate network? With TecknaEl Affiliate you can make money on your website while giving your visitors more functionality</p>
                        </div>
                        <div class="tools">
                            <p class="min-med p-black p-bold">Tools we offer:</p>

                            <ul>
                                <li>Easy to implement widgets (just copy the link)</li>
                                <li>Banners of several sizes (use ours or create your own)</li>
                                <li>Affilaite dahboard to track your progress or signed contract live</li>
                                <li>Two ways of earning (per signed contract or per click)</li>

                            </ul>
                        </div>
                        <div class="btns">
                            <button class="btn btn-green">Mail us <img src="../../../img/icon/envelope.svg" alt=""></button>
                        </div>
                    </div>
                    <div class="col-lg-5 d-flex flex-wrap d-lg-block align-items-center">
                        <div class="img__blck">
                            <div class="img__blck__info">
                                Fully responsive
                            </div>
                            <div class="right-arrow">
                                <img src="../../../img/affiliate/right-arrow.svg" alt="">
                            </div>
                            <div class="widjet-compare">
                                <div class="title">
                                    <p class="p-bold p-black p-center">SignEl widget</p>
                                </div>
                                    <widgetCompare></widgetCompare>
                            </div>
                            <div class="down-arrow">
                                <img src="../../../img/affiliate/down-arrow.svg" alt="">
                            </div>
                        </div>

                        <div class="link-example">
                            <p class="p-black p-bold p-center">Affiliate link example</p>
                            <div class="blk">
                                <p><span><</span>a href="<span class="p-blue">https://tecknael.se?affiliate=dsdsfjo</span>"<span>></span><span class="p-green">YOUR OWN LINK</span><span><</span>a<span>></span></p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="affiliate-partner-sect">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-md-12">
                        <div class="title">
                            <p class="p-title relawayBold p-black mb-0">Why partner up with TecknaEl?</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="partner__blck">
                            <div class="img">
                                <img src="../../../img/affiliate/transparency.svg" alt="">
                            </div>

                            <p class="min-med p-black p-bold">Transparent</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="partner__blck">
                            <div class="img">
                            <img src="../../../img/affiliate/Widgets.svg" alt="">
                            </div>
                            <p class="min-med p-black p-bold">Widgets</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="partner__blck">
                            <div class="img">
                            <img src="../../../img/affiliate/Dashboard.svg" alt="">
                            </div>
                            <p class="min-med p-black p-bold">Dashboard</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="partner__blck">
                            <div class="img">
                            <img src="../../../img/affiliate/responsive.svg" alt="">
                            </div>
                            <p class="min-med p-black p-bold">Easy to integrate, fully responsive</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="partner__blck">
                            <div class="img">
                            <img src="../../../img/affiliate/cellphone.svg" alt="">
                            </div>
                            <p class="min-med p-black p-bold">Easy to contact with us</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="partner__blck">
                            <div class="img">
                            <img src="../../../img/affiliate/Widgets_2.svg" alt="">
                            </div>
                            <p class="min-med p-black p-bold">Easy to implement</p>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ut labore et dolore magna aliqua</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="affiliate-abouttools-sect">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-md-12">
                        <div class="title">
                            <p class="p-title relawayBold p-black mb-0">About our tools in details</p>
                        </div>
                    </div>
                </div>
                    <div class="row aff-row">


                    <div class="col-lg-6 img-col">
                        <div class="img">
                            <img src="../../../img/affiliate/01.svg" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6 d-flex align-items-center content-col">
                        <div class="aff-content">
                            <p class="relawaySM p-black max-max">Easy to implement widgets </p>
                            <p>Through SignEl Affiliate, you can choose to integrate a SignEl widget directly into your platform. Just add this tag:</p>
                            <div class="blk">
                                <p><span><</span>iframe src="<span class="p-blue">https://tecknael.se/widget/0e833b80-b2d5-11e9-8823-0f577d92280c</span>"<span> scrolling="no"></span><span><</span>a<span>></span></p>

                            </div>
                            <p>This allows visitors to compare their electricity contracts through TecknaEl, completely free of charge. In addition to this, your visitors can easily find the right electricity contract for them, and you can also make money. You can learn more about widget integration on the
                                <a href="#">Documentation</a> page.</p>
                        </div>
                    </div>
                    </div>
                <div class="row aff-row">
                    <div class="col-lg-6 d-flex align-items-center content-col">
                        <div class="aff-content">
                            <p class="relawaySM p-black max-max">Affilaite dahboard to track your progress & adapt your widget </p>
                            <p>Drawing El Affiliate knows that many of our interested partners place great emphasis on comfortable aesthetics. We therefore adapt your widget to your graphic profile and wishes - but if you would like to change this on your own, you are given the tools for it on our DrawEl Affiliate control panel. There you can also monitor the traffic you drive, as well as see the conversion rate of your visitors.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 img-col">
                        <div class="img">
                            <img src="../../../img/affiliate/03.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="row aff-row">
                    <div class="col-lg-6 img-col">
                        <div class="img">
                            <img src="../../../img/affiliate/02.svg" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6 d-flex align-items-center content-col">
                        <div class="aff-content">
                            <p class="relawaySM p-black max-max">Two ways of earning Per signed contract or per click</p>
                            <p>SignEl Affiliate offers you the choice to either get paid on a “pay-per-click” or “pay-per-order” basis. Pay-per-click means you get paid a small amount for each person who clicks on your TecknaEl widget to compare electricity prices. Pay-per-order means you get paid a larger sum for each person who performs an electricity exchange through TecknaEl after using your widget.</p>
                        </div>
                    </div>
                </div>
                <div class="row aff-row">
                    <div class="col-lg-6 d-flex align-items-center content-col">
                        <div class="aff-content">
                            <p class="relawaySM p-black max-max">Affilaite dahboard to track your progress & adapt your widget </p>
                            <p>Drawing El Affiliate knows that many of our interested partners place great emphasis on comfortable aesthetics. We therefore adapt your widget to your graphic profile and wishes - but if you would like to change this on your own, you are given the tools for it on our DrawEl Affiliate control panel. There you can also monitor the traffic you drive, as well as see the conversion rate of your visitors.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 img-col">
                        <div class="banner__blck">
                            <div class="p-center">
                                <img src="../../../img/header/logo.svg" alt="">
                                <p class="relawaySM max-max p-black">TecknaEl banner example</p>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="btns">
                            <button class="btn btn-green">Mail us <img src="../../../img/icon/envelope.svg" alt=""></button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="affiliate-download-sect">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-md-12">
                        <div class="title">
                            <p class="p-title relawayBold p-black mb-0">Download banners</p>
                        </div>
                    </div>
                </div>
                <div class="banners-list">
                    <div class="banner-item">
                        <div class="banner-xl banner">
                            <p class="max-max relawaySM p-center mb-0">970х90 banner</p>
                        </div>
                        <button class="btn btn-blue small">Download</button>
                    </div>
                    <div class="banner-item">
                        <div class="banner-m banner">
                            <p class="max-max relawaySM p-center mb-0">728х90 banner</p>
                        </div>
                        <button class="btn btn-blue small">Download</button>
                    </div>
                    <div class="banner-item">
                        <div class="banner-s banner">
                            <p class="max-max relawaySM p-center mb-0">300x250 bannerr</p>
                        </div>
                        <button class="btn btn-blue small">Download</button>
                    </div>

                </div>
            </div>
        </div>
        <review bgColor="bg-color"></review>
        <faq-new background="bg-img bg-white"></faq-new>
    </div>
</template>
<script>
    import widgetCompare from './page-part/widget-compare'
    import FaqNew from './page-part/FaqNew';
    import Review from "../indexPartials/review"
    export default {
        name: "AffiliatePage",
        components:{
            FaqNew,
            Review,
            widgetCompare

        },
        data: function(){
            return {}
        }
    }
</script>
